// Validate object from creation of classificationObject and classficationXMLObject
// Checks for valid values:
// - No REL TO values in NOFORN
// - Check Classification/Classification Date/Declassfication Date
//
import dayjs from 'dayjs';
import {classificationOptionsOrder} from './../constants/definedTypes';

// Set the constructor to create initial arrays that will hold all validations/errors.
// Use final arrays to confirm all validations/errors.
export class ValidateObject {
    constructor(protected validArray: any[], protected errorArray: object[],
    ) {}

    // [MDEV-280] Ensure RELTO cannot be used with NOFORN
    // check for if NOFORN is valid (No REL TO options selected)
    noFornRelToCheck(jobject) {
        if (jobject['disseminationOptions']) {
            const dissOptions = jobject['disseminationOptions'];
            if (dissOptions.includes('NOFORN') && dissOptions.includes('REL TO')) {
                const _err = 'Dissemination options cannot contain both REL TO and NOFORN. Must contain one or the other.';
                this.validArray.push(false);
                this.errorArray.push({'NOFORN Check': _err});
                return _err;
            } else {
                this.validArray.push(true);
                return false;
            }
        } else {
            return false;
        }
    }

    // [MDEV-273] Extend Validation Utility
    // check for Classification, classficationDate, declassificationDate (Valid date/Manual review)
    // All three of these checks
    // Classification Check: If the object passed does not contain a classification key pass error to arrays
    // Otherwise pass truthy to array, and return false
    classificationCheck(jobject) {
        const classtype = classificationOptionsOrder;
        if (jobject['classification'] == null || jobject['classification'] == undefined || jobject['classification'] == '') {
            const _err = 'Error creating classification: No classfication specified';
            this.validArray.push(false);
            this.errorArray.push({'Classificaiton Check': _err});
            return _err;
        } else if (!classtype.includes(jobject['classification'])) {
            const _err = 'Error creating classification: Invalid classification';
            this.validArray.push(false);
            this.errorArray.push({'Classification Check': _err});
            return _err;
        } else {
            this.validArray.push(true);
            return false;
        }
    }

    // Classification Date Check: If the object passed does not contain a classification date key pass error to arrays
    // If the date passed is not in the valid format, pass error to arrays
    // Otherwise pass truthy to array, and return false
    classificationDateCheck(jobject) {
        const validDate = dayjs(jobject['classificationDate'], 'YYYY-MM-DD', true).isValid();
        if (jobject['classificationDate'] == null) {
            const _err = 'Error creating classification date: No classfication date specified';
            this.validArray.push(false);
            this.errorArray.push({'Classification Date Check': _err});
            return _err;
        } else if (!validDate) {
            const _err = 'Error creating classification date: Invalid classification date';
            this.validArray.push(false);
            this.errorArray.push({'Classification Date Check': _err});
            return _err;
        } else {
            this.validArray.push(true);
            return false;
        }
    }

    // Declassification Date Check: If the object passed does not contain a declassification date key pass error to arrays
    // If the date passed is not in the valid format, pass error to arrays
    // Date String may contain
    // Otherwise pass truthy to array, and return false
    declassificationDateCheck(jobject) {
        const validDate = dayjs(jobject['declassificationDate'], 'YYYYMMDD').isValid();
        if (!jobject['declassificationDate']) {
            const _err = 'Error creating declassification date: No declassfication date specified';
            this.validArray.push(false);
            this.errorArray.push({'Classification Date Check': _err});
            return _err;
        } else if (jobject['declassificationDate'] === 'Manual Review') {
            this.validArray.push(true);
            return false;
        } else if (!validDate) {
            const _err = 'Error creating classification date: Invalid declassification date';
            this.validArray.push(false);
            this.errorArray.push({'declassificaiton Date Check': _err});
            return _err;
        } else {
            this.validArray.push(true);
            return false;
        }
    }

    declassificationDateManualReviewCheck(jobject) {
        if (jobject['declassificationDate'] !== 'Manual Review') {
            // Manual Review tag is valid
            const _err = 'Error creating classification date: Invalid Manual Review';
            this.validArray.push(false);
            this.errorArray.push({'declassification Date Check': _err});
            return _err;
        } else {
            this.validArray.push(true);
            return false;
        }
    }

    // [MDEV-719] Check for valid classifiedBy username
    checkValidUser(jobject) {
        if (!jobject.classifiedBy) {
            const _err = `Invalid username provided for classifiedBy property: (${jobject.classifiedBy})`;
            this.validArray.push(false);
            this.errorArray.push({'Invalid classifiedBy username': _err});
            return _err;
        } else {
            this.validArray.push(true);
            return false;
        }
    }


    // Run check validator (run against all validators with this function)
    runValidatorCheck(obj) {
        // First basic check on validations [Classification, ClassificationDate, DeclassificationDate]
        this.classificationCheck(obj);
        this.classificationDateCheck(obj);
        this.declassificationDateCheck(obj);
        // check for if NOFORN is valid (No REL TO options selected)
        this.noFornRelToCheck(obj);
        // Check for valid classifiedBy username
        this.checkValidUser(obj);
        // Other validators go here
    }

    // callback to validate value in isValid function
    validCheck(val) {
        if (val) {
            return true;
        } else {
            return false;
        }
    }

    // return error array from the constructor
    invalidCallback() {
        return this.errorArray;
    }

    // Final check loop over all vals from callback
    isValid() {
        return this.validArray.every(this.validCheck);
    }
}
